import { styled } from "@mui/material";
import { useEffect, useState } from "react";
import { OutlineButton } from "@/components/StoreComponents/StoreButton";

const SubmitButton = styled(OutlineButton)<{ text: string }>(
  ({ theme, text }) => ({
    outline: "none",
    height: "40px",
    textAlign: "center",
    width: "100%",
    borderRadius: "40px",
    background: "#fff",
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,

    cursor: "pointer",
    transition: "all 0.25s ease",
    position: "relative",

    "&::after": {
      content: `"${text}"`,
    },

    "&.onclick": {
      width: "40px",
      height: "40px",
      borderColor: "#bbbbbb",
      borderWidth: "3px",
      fontSize: "0",
      borderLeftColor: theme.palette.primary.main,
      animation: "rotating 2s 0.25s linear infinite",

      "&::after": {
        content: '""',
      },
    },

    "&.validate": {
      width: "40px",
      height: "40px",
      fontSize: "13px",
      color: "white",
      background: "#1ECD97",
      borderColor: "#1ECD97",

      "&::after": {
        content: '"✔"',
      },
    },

    "@keyframes rotating": {
      from: {
        transform: "rotate(0deg)",
      },
      to: {
        transform: "rotate(360deg)",
      },
    },
  })
);

const AnimatedSubmittingButton = ({
  onClick,
  loading,
  disabled,
  text,
  animationCallback,
}: {
  onClick?: () => void;
  loading: boolean;
  disabled?: boolean;
  text: string;
  animationCallback?: () => void;
}) => {
  const [buttonState, setButtonState] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);

  const handleClick = () => {
    if (onClick) {
      setSubmitClicked(true);
      onClick();
    }
  };

  useEffect(() => {
    if (submitClicked) {
      if (loading) {
        setButtonState("onclick");
      } else {
        setTimeout(() => {
          setButtonState("validate");
          setTimeout(() => {
            animationCallback?.();
          }, 1250);
        }, 2250);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked, loading]);

  return (
    <SubmitButton
      text={text}
      className={buttonState}
      onClick={handleClick}
      disabled={disabled}
      disableMaxWidth
    />
  );
};

export default AnimatedSubmittingButton;
